import { Arrange, Button, SvgShare } from '@loomhq/lens';
import classNames from 'classnames';
import React from 'react';
import { useDispatch } from 'react-redux';

import { openModal } from 'actions/modals';
import { DESKTOP_MIN_WIDTH, TABLET_MAX_WIDTH } from 'constants/breakpoints';
import { SHARE_BUTTON_CLICKED } from 'constants/events';
import { SHARE_UI_MODAL } from 'constants/modalTypes';
import { SHARING_FEATURE_FTUX_CUTOFF } from 'constants/sharingFeatureFtux';
import * as analytics from 'utilities/analytics';
import { useShareModalFTUXTooltipState } from 'utilities/localStorage/ftux';

import { useGetSelectedWorkspace } from 'hooks/workspace';

import CopyLinkIconButton from '../share-ui/share/link-section/CopyLinkIconButton';
import MediaQuery from '../../media-query';

import FTUXTooltip from 'components/ftux-tooltip';

import styles from './styles.module.less';

const ShareModalButton = ({ userIsMemberOfVideoWorkspace, onClick }) => (
  <Button
    data-testid="share-modal-button"
    variant={userIsMemberOfVideoWorkspace ? 'primary' : 'neutral'}
    icon={<SvgShare />}
    onClick={onClick}
  >
    Share
  </Button>
);

const ShareButtonsWrapper = props => {
  const dispatch = useDispatch();
  const [tooltipDismissed, dismissTooltip] = useShareModalFTUXTooltipState();
  const onShareModalClick = () => {
    dispatch(openModal(SHARE_UI_MODAL));
    dismissTooltip();
    analytics.track(SHARE_BUTTON_CLICKED, {
      video_id: props.video.id,
    });
  };
  const isLoggedIn = Boolean(props.user?.id);

  const selectedWorkspace = useGetSelectedWorkspace();

  let userIsMemberOfVideoWorkspace = null;

  if (selectedWorkspace?.id) {
    userIsMemberOfVideoWorkspace =
      Number(selectedWorkspace.id) === props.video.organization_id;
  } else if (!isLoggedIn) {
    userIsMemberOfVideoWorkspace = false;
  }

  return (
    userIsMemberOfVideoWorkspace !== null && (
      <Arrange gap="small">
        <MediaQuery query={`(max-width: ${TABLET_MAX_WIDTH}px)`}>
          <CopyLinkIconButton videoId={props.video.id} />
          <ShareModalButton
            userIsMemberOfVideoWorkspace={userIsMemberOfVideoWorkspace}
            onClick={onShareModalClick}
          />
        </MediaQuery>
        <MediaQuery query={`(min-width: ${DESKTOP_MIN_WIDTH}px)`}>
          {!tooltipDismissed &&
            props.user &&
            props.user.createdAt < SHARING_FEATURE_FTUX_CUTOFF && (
              <div className={classNames(styles.ftuxContainer, 'relative')}>
                <FTUXTooltip
                  title="New sharing features!"
                  subtitle="Now you can share videos you create with specific people without copying and pasting the link. You can still keep sharing with a link just like always!"
                  dismissTooltip={dismissTooltip}
                />
              </div>
            )}
          <ShareModalButton
            userIsMemberOfVideoWorkspace={userIsMemberOfVideoWorkspace}
            onClick={onShareModalClick}
          />
          <CopyLinkIconButton videoId={props.video.id} />
        </MediaQuery>
      </Arrange>
    )
  );
};

export default ShareButtonsWrapper;
